export enum KEYBOARD_PLAYER_CODES {
  SPACE_KEY = 'Space',
  ARROW_LEFT_KEY = 'ArrowLeft',
  ARROW_RIGHT_KEY = 'ArrowRight',
  ENTER_KEY = 'Enter',
}
